import request from '@/utils/request'
import { v2Host } from '@/config/host'

// http://playable.dev.com:8067/?doc=pt/playturbo%2fhandler%2fdmaker%2fcustom.go

export function fetchTemplateVersion(params) {
  return request({
    url: `${v2Host}/dmaker/custom/list`,
    method: 'get',
    params: params,
  })
}

export function createTemplateVersion(data) {
  return request({
    url: `${v2Host}/dmaker/custom/create`,
    method: 'post',
    data: data,
  })
}

export function deleteTemplateVersion(data) {
  return request({
    url: `${v2Host}/dmaker/custom/delete`,
    method: 'post',
    data: data,
  })
}

export function changeVersionName(data) {
  return request({
    url: `${v2Host}/dmaker/custom/rename`,
    method: 'post',
    data: data,
  })
}

export function fetchNextCustomVersionId(params) {
  return request({
    url: `${v2Host}/dmaker/custom/next-version`,
    method: 'get',
    params,
  })
}

export function resetDmakerCustom({ id }) {
  return request({
    url: `${v2Host}/dmaker/custom/reset`,
    method: 'post',
    params: {
      id,
    },
  })
}

export function getDmakerCustomOriginalInfo(params) {
  return request({
    url: `${v2Host}/dmaker/custom/init-json`,
    method: 'get',
    params,
  })
}

export function packageCustomVersion(data) {
  return request({
    url: `${v2Host}/dmaker/custom/pack`,
    method: 'post',
    data: data,
  })
}

// 定制广告普通制作-编辑版本信息
export function customVersionUpdate(data) {
  return request({
    url: `${v2Host}/dmaker/custom/update`,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    data,
  })
}

// 定制广告多组合制作-编辑版本信息
export function mgroupVersionUpdate(data) {
  return request({
    url: `${v2Host}/dmaker/mgroup/update`,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    data,
  })
}
